import { Component, Input, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { HelperService } from 'app/services';
import { QboToastService } from 'app/services/qbo.toast.service';
import { Subscription } from 'rxjs';

export type ToastType = 'success' | 'error' | 'warning';
export interface Toast {
  type: ToastType;
  title: string;
  posted: number;
  pending: number;
  failed: number;
  body: string;
  delay: number;
}

@Component({
  selector: 'app-qbo-taost',
  templateUrl: './qbo-taost.component.html',
  styleUrls: ['./qbo-taost.component.scss'],
})
export class QboTaostComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  toast: Toast;
  toastSub: Subscription;
  i: number;
  dismissUniqueId: number;

  constructor(private toaster: QboToastService, private helperService: HelperService) {}

  ngOnInit() {
    this.toastSub = this.toaster.toast$.subscribe((toast) => {
      let toastrMap = {};
      this.toaster.toasters.forEach((data) => {
        toastrMap[data.uniqueId] = data;
      });
      this.toasts.forEach((toastr: any, index) => {
        if (!toastrMap[toastr.uniqueId]) {
          this.toasts.splice(index, 1);
          return;
        }
        this.toasts[index]['isComplete'] = toastrMap[toastr.uniqueId].isComplete || false;
        this.toasts[index]['isBulkStatementSent'] = toastrMap[toastr.uniqueId].isBulkStatementSent || false;
        this.toasts[index]['totalStatements'] = toastrMap[toastr.uniqueId].totalStatements;
        this.toasts[index]['totalInvoice'] = toastrMap[toastr.uniqueId].totalCount;
        this.toasts[index]['successCount'] = toastrMap[toastr.uniqueId].successCount;
        this.toasts[index]['failedCount'] = toastrMap[toastr.uniqueId].failedCount;
        this.toasts[index]['pendingCount'] = toastrMap[toastr.uniqueId].pendingCount;
        if (this.toasts[index]['isBulkStatementSent'] && this.toasts[index]['isComplete']) {
          // dismiss dialog after 10 sec
          setTimeout(() => {
            this.toasts = [];
          }, 10000);
        } else {
          delete toastrMap[toastr.uniqueId];
        }
      });
      Object.keys(toastrMap).forEach((key) => {
        this.toasts.push(toastrMap[key]);
      });
    });
  }
  ngOnDestroy() {
    this.toastSub.unsubscribe();
  }

  dismiss() {
    this.helperService.openPageInNewTab(`/customers/statements`);
    this.toasts = [];
  }
}
